import { PropsWithChildren, createContext, useCallback, useContext, useMemo, useState } from 'react';

import { createTheme } from '@mui/material';
import type { PaletteMode, Theme } from '@mui/material';

import { LightTheme, DarkTheme, ComponentStyleOverrides } from '../theme';

interface ThemeValues {
  theme: Theme;
  setThemeMode: (theme: PaletteMode) => void;
}
const ThemeContext = createContext<ThemeValues>({
  theme: createTheme({ ...LightTheme, components: ComponentStyleOverrides }),
  setThemeMode: () => {},
});

export const ThemeProvider = ({ children }: PropsWithChildren) => {
  const [theme, setTheme] = useState<Theme>(() => createTheme({ ...LightTheme, components: ComponentStyleOverrides }));

  const setThemeMode = useCallback((themeMode: PaletteMode) => {
    // TODO: Override this with user defined theme
    setTheme(createTheme({ ...(themeMode === 'light' ? LightTheme : DarkTheme), components: ComponentStyleOverrides }));
  }, []);

  const value = useMemo(
    () => ({
      theme,
      setThemeMode,
    }),
    [theme, setThemeMode],
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useThemeContext = () => useContext(ThemeContext);
